import React, { FC } from 'react'

import { BackArrowIcon } from '../Icons'

import { Wrap } from './styled'

interface Props {
  label: string
  type: 'button' | 'submit' | 'reset'
  disabled: boolean
  onClick: () => void
}

export const BackButton: FC<Props> = ({ label, type, disabled, onClick }) => (
  <Wrap type={type} disabled={disabled} onClick={onClick}>
    <BackArrowIcon />
    <p>{label}</p>
  </Wrap>
)
